import React from "react";

const CallToAction = () => {
  return (
    <section
      className="call-to-action-area call-to-action-5 bg-image bg-overlay-theme-90 pt-40 pb-25"
      style={{
        backgroundImage: "url('/img/bg/13.jpg')",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="call-to-action-inner call-to-action-inner-5 text-center">

              <h2 className="white-color text-white">
                24/7 Availability, Make{" "}
                <a href="" className="text-white">
                  An Appointment
                </a>
              </h2>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
